import { getContext } from '@fiverr-private/fiverr_context';
import { howLongAgo } from '@fiverr-private/futile';

/**
 * Formats the time elapsed since a given date.
 **/

const MILLIS_IN_SECONDS = 1000;

const formatTimeSince = (createdAt: number) => {
    const { locale } = getContext();
    const createdAtInMs = createdAt * MILLIS_IN_SECONDS;

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return howLongAgo(createdAtInMs, { prefix: 'brief_preview_drawer.how_long_ago.', locale });
};

export default formatTimeSince;
